
// Dropdown and mega menu

const ddButtons = document.getElementsByClassName("mob-parent-button");

// Loop through each button
for (const ddButton of ddButtons) {
  // Add a click event listener to the button
  ddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the button click
    event.preventDefault();
    // Find the next sibling element and add the "active" class to it
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      updateSlHideVisibility();
    }
  });
} 

const ddPanels = document.querySelectorAll(".mob-secondary-level-ul, .mob-third-level-ul");

// Function to update the visibility of sl-hide divs
function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");

  for (const slHideDiv of slHideDivs) {
    if (isActivePanel) {
      slHideDiv.classList.add("sl-hide-oi");
    } else {
      slHideDiv.classList.remove("sl-hide-oi");
    }
  }
}

// Loop through each panel
for (const ddPanel of ddPanels) {
  // Find the "nav-secondary-fo-back-button" within the current panel
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");

  // Add a click event listener to the back button
  backButton.addEventListener("click", function () {
    // Remove the "active" class from the parent panel
    ddPanel.classList.toggle("active");
    updateSlHideVisibility();
  });

  // Create a MutationObserver for each panel
  const panelObserver = new MutationObserver(() => {
    updateSlHideVisibility();
  });

  // Define what to observe within the panel for specific changes
  const observerConfig = { subtree: true, childList: true, attributes: true, characterData: true };

  // Start observing the panel for changes
  panelObserver.observe(ddPanel, observerConfig);
}


// Accordion menu system

document.addEventListener("DOMContentLoaded", function () {
  var drawerAccordionButtons = document.querySelectorAll(".mob-parent-accordion-button");
  drawerAccordionButtons.forEach(function (drawerAccordionButton) {
    drawerAccordionButton.addEventListener("click", function () {
      var panel = drawerAccordionButton.nextElementSibling;

      // Toggle the "open" class for the accordion heading
      if (drawerAccordionButton.classList.contains("active")) {
        drawerAccordionButton.classList.remove("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'false');
        panel.style.height = null;
        setTimeout(function () {
          panel.classList.remove("panel-open");
          panel.setAttribute('aria-hidden', 'true');
        }, 600);
      } else {
        drawerAccordionButton.classList.add("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.scrollHeight + "px";
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add("panel-open");
      }
    });
  });
});


// Dropdown menu interaction
if (!document.querySelector('.nav-desktop-dd-btn-clickable')) {
  const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
  const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
  const gcHeader = document.querySelector('.header-bar-inner');
    
  function applyBackgroundColor() {
    gcHeader.classList.add('hovered');
  }
  
  function removeBackgroundColor() {
    gcHeader.classList.remove('hovered');
  }
  
  navDesktopButtons.forEach((navDesktopButton) => {
    navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
    navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
  });
  
  headerMegaFwLists.forEach((headerMegaFwList) => {
    headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
    headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
  });
}

// Scrolling transition for transparent header option

const headerDiv = document.getElementById('SiteHeader');
const hadHdrTransHpInitially = headerDiv.classList.contains('hdr-trans-hp');
let isScrolled = false;

window.addEventListener('scroll', function() {
  const scrollPosition = window.pageYOffset;

  if (scrollPosition > 250 && !isScrolled) {
    headerDiv.classList.remove('hdr-trans-hp');
    isScrolled = true;
  } else if (scrollPosition <= 250 && isScrolled) {
    if (hadHdrTransHpInitially) {
      headerDiv.classList.add('hdr-trans-hp');
    }
    isScrolled = false;
  }
});



// Menu drawer opening and closing

var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtns = document.querySelectorAll('.hdr-menu-button');
var navclose = document.getElementById('mobNavDrawerClose');
var lastFocusedButton = null;

// Function to open the menu drawer and set focus to the close button
function openMenuDrawer(event) {
  lastFocusedButton = event.currentTarget;
  navdrawermobile.classList.toggle('open');
  drawbg.classList.toggle('open');
  if (navdrawermobile.classList.contains('open')) {
    setTimeout(() => {
      navclose.focus();
    }, 200);
  }
  event.preventDefault();
}

// Event listeners to each menu button
navbtns.forEach(navbtn => {
  navbtn.addEventListener('click', openMenuDrawer);

  navbtn.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      openMenuDrawer(event);
    }
  });
});

if (navclose) { 
  navclose.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    lastFocusedButton?.focus();
  });
}

if (drawbg) { 
  drawbg.addEventListener('click', function() {
    navdrawermobile.classList.remove('open');
    drawbg.classList.remove('open');
    lastFocusedButton?.focus();
  });
}

// Desktop dropdowns for click option
var panelBg = document.querySelector('.dd-click-drawer-bg');
var lastClickedButton = null;

document.querySelectorAll('.nav-desktop-dd-btn-clickable').forEach(item => {
  item.addEventListener('click', (event) => {
    event.preventDefault();

    const panel = item.nextElementSibling;
    const isSameButton = lastClickedButton === item;
    const gcHeader = document.querySelector('.header-bar-inner');

    // Hide all other panels
    document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(p => {
      if (p !== panel) {
        p.classList.remove("dd-visible");
      }
    });

    if (panel) {
      if (isSameButton) {
        // If clicking the same button, toggle the background visibility
        panel.classList.toggle("dd-visible");
        panelBg.classList.toggle("visible");
        gcHeader.classList.add('hovered');        
      } else {
        // If clicking a different button, ensure background stays visible
        panel.classList.add("dd-visible");
        panelBg.classList.add("visible");
        gcHeader.classList.add('hovered');
      }
    }

    // Update last clicked button
    lastClickedButton = isSameButton ? null : item;
  });
});

// Close all dropdowns when clicking anywhere outside
if (!document.querySelector('.nav-desktop-dd-btn-hover')) {
  document.addEventListener('click', (event) => {
    // Check if the clicked target is not inside a dropdown or clickable button
    if (
      !event.target.closest('.header-nav-desktop-dd-panel') &&
      !event.target.closest('.nav-desktop-dd-btn-clickable') &&
      !event.target.closest('.hdr-search-btn')
    ) {
      // Hide all dropdowns
      document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(panel => {
        panel.classList.remove("dd-visible");
        panelBg.classList.remove("visible");
        document.querySelector('.header-bar-inner').classList.remove('hovered');
      });
    }
  });
}


// === Unsubscribe/guard clicks on collection columns =========================
(function () {
  const VALID_ANCHOR_SELECTOR = 'ul li > a, a[data-allow-click]'; 
  // ^ Only these anchors are allowed to navigate

  function killInlineOnclick(col) {
    // Remove inline onclick handlers if present
    col.removeAttribute('onclick');
    try { col.onclick = null; } catch (_) {}
  }

  function isClickOverHeading(col, evt) {
    const heading = col.querySelector('.dd-nav-column-heading');
    if (!heading) return false;

    // Use pointer position to detect clicks over the heading box
    const rect = heading.getBoundingClientRect();
    const point = (evt.touches && evt.touches[0]) || evt;
    const x = point.clientX, y = point.clientY;
    if (typeof x !== 'number' || typeof y !== 'number') return false;

    return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  }

  function isValidAnchorClick(col, target) {
    const a = target.closest('a');
    return !!(a && col.contains(a) && a.matches(VALID_ANCHOR_SELECTOR));
  }

  function attachColumnGuard(col) {
    killInlineOnclick(col);
    if (col.__ddGuardAttached) return;

    const guard = (evt) => {
      // Block clicks over heading area, regardless of stretched links
      if (isClickOverHeading(col, evt)) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }

      // Allow only clicks on valid anchors inside the list
      if (!isValidAnchorClick(col, evt.target)) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
    };

    // Capture phase to win over existing delegated/onbubble listeners
    col.addEventListener('click', guard, true);
    col.addEventListener('mousedown', guard, true);
    col.addEventListener('touchstart', guard, { capture: true, passive: false });

    // Accessibility/UX: make headings non-interactive
    const heading = col.querySelector('.dd-nav-column-heading');
    if (heading) {
      heading.style.cursor = 'default';
      heading.setAttribute('role', 'heading');
      heading.setAttribute('aria-level', '3');
      heading.setAttribute('tabindex', '-1');
    }

    col.__ddGuardAttached = true;
  }

  function scanColumns() {
    document
      .querySelectorAll('.header-nav-desktop-dd-panel-col')
      .forEach(attachColumnGuard);
  }

  // Initial pass
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanColumns);
  } else {
    scanColumns();
  }

  // Re-apply guard if menu re-renders or attributes change
  const root = document.querySelector('.header-nav-desktop-dd-panel') || document.body;
  new MutationObserver(() => { scanColumns(); }).observe(root, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['onclick', 'class']
  });
})();


// Shrink logo when any desktop dropdown panel is visible
(function(){
  const header = document.querySelector('.header-bar-inner');
  const logo   = document.querySelector('.header--logo-std');
  const panels = document.querySelectorAll('.header-nav-desktop-dd-panel');
  if (!header || !logo || !panels.length) return;

  // Heuristics: adapt to how your theme marks "visible"
  const isPanelVisible = (p) =>
    p.classList.contains('dd-visible') ||          // click version
    p.matches(':hover') ||                         // hover version
    p.getAttribute('aria-hidden') === 'false' ||   // accessibility state
    (!p.hasAttribute('hidden') && getComputedStyle(p).display !== 'none');

  const refresh = () => {
    const open = Array.from(panels).some(isPanelVisible);
    logo.classList.toggle('logo--shrink', open);
  };

  // React on attribute/class changes and pointer interactions
  const mo = new MutationObserver(refresh);
  panels.forEach(p => {
    mo.observe(p, { attributes: true, attributeFilter: ['class','hidden','aria-hidden','style'] });
    p.addEventListener('mouseenter', refresh);
    p.addEventListener('mouseleave', refresh);
  });

  // Also reflect the existing "hovered" class if your JS toggles it
  const headerMO = new MutationObserver(refresh);
  headerMO.observe(header, { attributes: true, attributeFilter: ['class'] });

  // Initial state
  refresh();
})();
